import { render, staticRenderFns } from "./financeiro-cadastro-grupo-hospital.vue?vue&type=template&id=ef6907e6"
import script from "./financeiro-cadastro-grupo-hospital.vue?vue&type=script&lang=ts"
export * from "./financeiro-cadastro-grupo-hospital.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports